<h1 mat-dialog-title> {{ data.length === 1 ? "Position" : "Positionen" }} prüfen (Anzahl & Gesamtpreis) </h1>

<mat-dialog-content>
    <div *ngFor="let pos of data" style="width: 100%">
        Position {{ pos?.position }}: {{ pos?.menge }}x {{ pos?.artikel }} =
        <strong> {{ pos?.preis }}€ </strong>
    </div>
    <p>
        Bitte bestätigen Sie, dass die
        {{ data.length === 1 ? "Position" : "Positionen" }} korrekt ist.
    </p>
</mat-dialog-content>

<mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button (click)="dialogRef.close(true)" color="accent" mat-flat-button>Bestätigen</button>
</mat-dialog-actions>
